import { createSlice } from "@reduxjs/toolkit";
import { SocialLinksThunk } from "../Thunk/SocialLinksThunk";
import { StoreAndUpdateSocialLinksThunk } from "../Thunk/StoreAndUpdateSocialLinksThunk";

let initState = {
	reload: false,
	socialLinkData: {},
	error: null,
};

const SocialLinksReducer = createSlice({
	name: "SocialLinks",

	initialState: initState,
	reducers: {},
	extraReducers: (builder) => {
		builder

			.addCase(StoreAndUpdateSocialLinksThunk.pending, (state) => {
				state.reload = true;
			})
			.addCase(StoreAndUpdateSocialLinksThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.socialLinkData = action.payload.data;
			})
			.addCase(StoreAndUpdateSocialLinksThunk.rejected, (state, action) => {
				state.reload = false;
				state.error = action.payload;
			})

			.addCase(SocialLinksThunk.pending, (state) => {
				state.reload = true;
			})
			.addCase(SocialLinksThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.socialLinkData = action.payload.data;
			})
			.addCase(SocialLinksThunk.rejected, (state, action) => {
				state.reload = false;
				state.error = action.error.message;
			});
	},
});
export default SocialLinksReducer.reducer;
